import { Link, useNavigate } from "react-router-dom";
import FormContainer from "../components/common/FormElements/FormContainer";
import FormHeader from "../components/common/FormElements/FormHeader";
import OtpInput from "../components/common/FormElements/OtpInput";
import SubmitButton from "../components/common/FormElements/SubmitButton";
import { useState, FormEvent } from "react";
import { ErrorType } from "../types/errorType";
import FormError from "../components/common/FormElements/FormError";

export type OtpType = {
  one: string;
  two: string;
  three: string;
  four: string;
};

const VerifyEmailForRegistration = () => {
  // navigate variable for navigate to another page
  const navigate = useNavigate();

  // loading state
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // error state
  const [isError, setIsError] = useState<ErrorType>({
    errorType: "",
    errorMessage: "",
  });
  const [data, setData] = useState<OtpType>({
    one: "",
    two: "",
    three: "",
    four: "",
  });

  const formHandler = (e: FormEvent<HTMLFormElement>) => {
    // prevent default form submit behavior
    e.preventDefault();

    // set all error property to empty on submit the form
    setIsError({
      errorType: "",
      errorMessage: "",
    });

    // start loading
    setIsLoading(true);
    const otp = `${data.one}${data.two}${data.three}${data.four}`;

    // if any input field is empty it will give error message under the form or go to the next step
    if (!data.one || !data.two || !data.three || !data.four) {
      setTimeout(() => {
        setIsLoading(false);
        setIsError({
          errorType: "error",
          errorMessage: "Please type 4 digit code",
        });
      }, 500);
    } else {
      setTimeout(() => {
        console.log(otp);
        setIsLoading(false);
        setIsError({
          errorType: "success",
          errorMessage: "Email verified!",
        });
      }, 500);
      setTimeout(() => {
        navigate("/login");
      }, 1000);
    }
    setData({
      one: "",
      two: "",
      three: "",
      four: "",
    });
  };

  return (
    <FormContainer>
      <FormHeader
        labelText="Enter OTP"
        subheading="We've sent a verification code to your email."
      />
      <form
        className="w-full flex flex-col gap-5"
        onSubmit={(e: FormEvent<HTMLFormElement>) => formHandler(e)}
      >
        <OtpInput data={data} setData={setData} />
        <SubmitButton buttonLabel="Submit" isLoading={isLoading} />
        {isError.errorType && <FormError errorObject={isError} />}
      </form>
      <div className="flex gap-1 items-center">
        <p className="text-slate-500 sm:text-sm md:text-base">
          Didn't get the code?
        </p>
        <Link
          to="/forgot"
          className="text-violet-500 w-max sm:text-sm md:text-base"
        >
          Resend (1/2)
        </Link>
      </div>
    </FormContainer>
  );
};

export default VerifyEmailForRegistration;
